import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { CollateralSkillSet, AddSkillset } from '../collateralskillset.model';
import { CollateralskillsetsService } from '../collateralskillsets.service';

@Component({
    selector: 'app-collateralskillset-add',
    templateUrl: './collateralskillset-add.component.html',
    styleUrls: ['./collateralskillset-add.component.css']
})
export class CollateralskillsetAddComponent implements OnInit {

    public collateralSkillSetForm: FormGroup;
    public productSkillSets;

    constructor(
        public dialogRef: MatDialogRef<CollateralskillsetAddComponent>, private fb: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public collateralSkillSet: CollateralSkillSet,private collateralSkilSetService :CollateralskillsetsService
    )
    { this.createForm(); }

    ngOnInit() {
       this.getProductSkillset();
    }

    createForm() {
        this.collateralSkillSetForm = this.fb.group({
            name: ['', [Validators.required, Validators.maxLength(255)]],
            productSkillSet: [null, Validators.required]
        });
    }
    onSubmit() {
        if (!this.collateralSkillSetForm.valid) {
            return;
        }
        const formModel = this.collateralSkillSetForm.value;
        const saveSkillset: AddSkillset = {
            name: formModel.name as string,
            productSkillsetId: formModel.productSkillSet as string
        };
        this.collateralSkilSetService.addCollateralSkillset(saveSkillset)
            .then(result => this.dialogRef.close(result))
            .catch(error => console.log(error));
    }

    async getProductSkillset() {
        let result = await this.collateralSkilSetService.getProductSkillSet();
        this.productSkillSets = result;
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/collateralskillsets/collateralskillset-add/collateralskillset-add.component.ts